var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.943,
    height: 19.949,
    viewBox: "0 0 19.943 19.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4852",
    "data-name": "Rectangle 4852",
    width: 19.943,
    height: 19.949,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10132",
    "data-name": "Group 10132",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10131",
    "data-name": "Group 10131",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5693",
    "data-name": "Path 5693",
    d: "M8.355,18.84a.461.461,0,0,0,.053.47.434.434,0,0,0,.455.156l4.188-1.086L16.04,15.4l.01,2.794a1.74,1.74,0,0,1-1.782,1.757L1.677,19.94A1.718,1.718,0,0,1,0,18.185L0,1.719A1.718,1.718,0,0,1,1.718,0l9.121,0V2.564A2.615,2.615,0,0,0,13.379,5.21H16.05l0,2.83L9.889,14.2ZM4.334,5.634A.429.429,0,0,0,4.771,5.2V2.611a.443.443,0,0,0-.46-.443H1.756a.443.443,0,0,0-.454.456l.006,2.6a.426.426,0,0,0,.446.415ZM9.992,3.462a.417.417,0,0,0,.41-.447A.423.423,0,0,0,9.971,2.6H6.058a.425.425,0,0,0-.416.446.43.43,0,0,0,.417.414ZM8.712,5.194A.428.428,0,0,0,8.7,4.341l-2.6,0a.432.432,0,1,0-.038.863ZM4.333,10.41a.434.434,0,0,0,.437-.44V7.381a.439.439,0,0,0-.46-.437l-2.555,0a.427.427,0,0,0-.449.415l0,2.6a.443.443,0,0,0,.454.456ZM9.952,8.242a.433.433,0,1,0,.019-.865l-3.91,0a.43.43,0,0,0,0,.859ZM8.713,9.974a.443.443,0,0,0,.393-.45.426.426,0,0,0-.41-.411H6.057a.429.429,0,0,0,0,.858Zm-4.338,5.21a.439.439,0,0,0,.4-.446l0-2.588a.437.437,0,0,0-.458-.43H1.756a.437.437,0,0,0-.452.441l0,2.563a.442.442,0,0,0,.412.459Zm5.62-2.171a.418.418,0,0,0,.407-.459.431.431,0,0,0-.434-.4l-3.9,0a.427.427,0,0,0-.425.438.436.436,0,0,0,.459.426Zm-1.32,1.73A.425.425,0,0,0,9.1,14.3a.433.433,0,0,0-.446-.415l-2.6,0a.428.428,0,0,0,0,.857Z",
    transform: "translate(0 0)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4848",
    "data-name": "Rectangle 4848",
    width: 6.938,
    height: 3.47,
    transform: "matrix(0.706, -0.708, 0.708, 0.706, 10.856, 14.452)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5694",
    "data-name": "Path 5694",
    d: "M15.846,4.344a1.737,1.737,0,0,1-1.757-1.736L14.1.007l4.318,4.33Z",
    transform: "translate(-2.382 -0.001)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5695",
    "data-name": "Path 5695",
    d: "M22.148,12.965,19.7,10.517l.67-.663a1.712,1.712,0,0,1,2.424.077,1.734,1.734,0,0,1-.038,2.435Z",
    transform: "translate(-3.33 -1.587)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M14.58,20.573l-3.365.932.923-3.376Z",
    transform: "translate(-1.896 -3.065)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4849",
    "data-name": "Rectangle 4849",
    width: 1.733,
    height: 1.735,
    transform: "translate(2.171 3.037) rotate(-0.137)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4850",
    "data-name": "Rectangle 4850",
    width: 1.733,
    height: 1.734,
    transform: "translate(2.172 7.81) rotate(-0.137)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4851",
    "data-name": "Rectangle 4851",
    width: 1.734,
    height: 1.734,
    transform: "translate(2.172 12.582)",
    fill: "#d13c3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.ec8c7ec34eb3c7d190df86fa5284b3d8.svg";
export { ForwardRef as ReactComponent };